import { createRouter, createWebHistory } from "vue-router";
import Signin from "../views/Signin.vue";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/signin",
    name: "sign",
    component: Signin,
  },
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/signup",
    name: "singup",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Signup.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
